export default function SeriesTamisConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('series.tamis');
}

SeriesTamisConfiguration.$inject = ['$translatePartialLoaderProvider'];
